import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createTaxConfig,
  deleteTaxConfig,
  getAllTaxConfigs,
  updateTaxConfig,
} from "controller";
import { ApiErrorType, GetQueryProps } from "shared";
import { sentryLogger } from "utilz";

export const useGetAllTaxConfigs = ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
}: GetQueryProps) => {
  return useQuery({
    queryKey: [
      "taxConfigs",
      perPageCount,
      pageNumber,
      filter,
      searchQuery,
      sortDirection,
      sortColumn,
    ],
    queryFn: () =>
      getAllTaxConfigs({
        perPageCount,
        pageNumber,
        sortColumn,
        sortDirection,
        filter,
        searchQuery,
      }),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getAllTaxConfigs",
      });
    },
  });
};

export const useCreateTaxConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => createTaxConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taxConfigs"] });
      queryClient.invalidateQueries({ queryKey: ["billingTemplates"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "createTaxConfig",
      });
    },
  });
};

export const useDeleteTaxConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { tax_ids: string[] }) => deleteTaxConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taxConfigs"] });
      queryClient.invalidateQueries({ queryKey: ["billingTemplates"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "deleteTaxConfig",
      });
    },
  });
};

export const useUpdateTaxConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => updateTaxConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taxConfigs"] });
      queryClient.invalidateQueries({ queryKey: ["billingTemplates"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "updateTaxConfig",
      });
    },
  });
};
